import React, { useEffect, useState } from "react";
import "./Reviews.css";

const LatestGoogleReviewCard = () => {
  const [latestReview, setLatestReview] = useState(null);

  useEffect(() => {
    const url =
      process.env.NODE_ENV === "development"
        ? "http://127.0.0.1:8000/get_last_review"
        : "https://last-resort-api.azurewebsites.net/get_last_review";

    fetch(url, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setLatestReview(data); // Store the entire review object
        console.log(data); // Log for debugging
      })
      .catch((error) => {
        console.log("Error fetching reviews:", error);
      });
  }, []); // Empty dependency array ensures this runs once on component mount

  if (!latestReview) return <div>Loading review...</div>; // Display loading message while fetching review data

  return (
    <div className="review-card-container">
      <div className="review-card-floating">
        <div className="review-content">
          <div className="review-header">
            <div className="avatar">{latestReview.author?.charAt(0)}</div>
            <div>
              <div className="review-author">{latestReview.author}</div>
              <div className="review-rating">
                {"★".repeat(latestReview.rating || 0)}{" "}
                {"☆".repeat(5 - (latestReview.rating || 0))}
              </div>
            </div>
          </div>
          <p className="review-text">“{latestReview.review}”</p>
          <p className="review-source">
            <a
              href="https://www.google.co.uk/maps/place/The+Last+Resort/@54.9835107,-1.5842476,17z/data=!4m8!3m7!1s0x487e71b9af55bab1:0x13d79678d43a312!8m2!3d54.9835076!4d-1.5816727!9m1!1b1!16s%2Fg%2F11whwxl863?entry=ttu&g_ep=EgoyMDI1MDQyNy4xIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Review
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LatestGoogleReviewCard;
